import React, { useRef } from 'react';
import { Button, ButtonHierarchies } from '@clockout-dev/design-elements';
import { UploadOutlined } from '@ant-design/icons';
import styles from './styles/freeAdvances.module.scss';

/**
 * "Import CSV" — reads the file client-side and hands its raw text to the
 * controller (which parses via utils/csv and stages the ids). No upload:
 * unlike the access-list bulk flow (ImportListModal + backend job), staged
 * members here just ride the drawer's normal Save, so the file never needs
 * to leave the browser.
 *
 * Renders as a compact text action rather than a filled button: it sits in the
 * Members section header next to the title, where a full-width primary button
 * would outrank both the roster it feeds and the drawer's own Save.
 */
function CsvImportButton({ onImport, disabled }) {
    const inputRef = useRef(null);

    const handleFile = (event) => {
        const file = event.target.files?.[0];
        // Reset so picking the same (possibly corrected) file re-fires change.
        event.target.value = '';
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => onImport(String(reader.result || ''));
        reader.readAsText(file);
    };

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept=".csv,.txt,text/csv,text/plain"
                className={styles.hiddenFileInput}
                onChange={handleFile}
            />
            <Button
                type="button"
                hierarchy={ButtonHierarchies.LINK_COLOR}
                icon={<UploadOutlined />}
                onClick={() => inputRef.current?.click()}
                disabled={disabled}
            >
                Import CSV
            </Button>
        </>
    );
}

export default CsvImportButton;
